var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(-0.264)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0.264)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.857,16H2.143a2.111,2.111,0,0,1-1.517-.637A2.189,2.189,0,0,1,0,13.818L.011,2.182A2.2,2.2,0,0,1,.631.637,2.1,2.1,0,0,1,2.143,0H17.857a2.111,2.111,0,0,1,1.517.637A2.189,2.189,0,0,1,20,2.182V13.818a2.189,2.189,0,0,1-.625,1.545A2.111,2.111,0,0,1,17.857,16ZM2.143,7.273v6.546H17.857V7.273Zm0-5.091V4.364H17.857V2.182Z",
    transform: "translate(-0.264)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayment);
export default __webpack_public_path__ + "static/media/icon-payment.7572c021b254931a5ea872447175bff7.svg";
export { ForwardRef as ReactComponent };